<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container *transloco="let t; read 'layout'">
  <c-container [fluid]="true" class="border-bottom px-4">
    <button [cSidebarToggle]="sidebarId" cHeaderToggler class="btn" toggle="visible"
      style="margin-inline-start: -14px;">
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>
    <c-header-nav class="d-md-flex">
      <c-nav-item class="d-none d-sm-flex">
        <a cNavLink routerLink="/tracker" routerLinkActive="active">{{ t('Dashboard') }}</a>
      </c-nav-item>
      <c-nav-item class="d-none d-sm-flex">
        <a cNavLink routerLink="/market" routerLinkActive="active">{{ t('Market') }}</a>
      </c-nav-item>
      <c-nav-item class="d-block d-sm-none">
        <a cNavLink routerLink="/tracker" cTooltip="Price Tracker" [cTooltipVisible]="showMarketTracker"
          cTooltipTrigger="hover" routerLinkActive="active">
          <img src="assets/svg/tracker-{{currentMode}}.svg" height="24px" width="24px" />
        </a>
      </c-nav-item>
      <c-nav-item class="d-block d-sm-none">
        <a cNavLink routerLink="/market" cTooltip="Market Place" [cTooltipVisible]="showMarketPlace"
          cTooltipTrigger="hover" routerLinkActive="active">
          <img src="assets/svg/market-{{currentMode}}.svg" height="24px" width="24px" />
        </a>
      </c-nav-item>

    </c-header-nav>
    @if (userService.loggedIn){
    <c-header-nav class="d-md-flex">
      <c-nav-item class="d-none d-sm-flex">
        <a cNavLink routerLink="/posts" routerLinkActive="active">{{ t('Posts') }}</a>
      </c-nav-item>
      <c-nav-item class="d-none d-sm-flex">
        <a cNavLink routerLink="/contracts" routerLinkActive="active">{{ t('Contracts') }}</a>
      </c-nav-item>
      <c-nav-item class="d-block d-sm-none">
        <a cNavLink routerLink="/posts" cTooltip="My Posts" [cTooltipVisible]="showMyPosts" cTooltipTrigger="hover"
          routerLinkActive="active">
          <img src="assets/svg/posts-{{currentMode}}.svg" height="24px" width="24px" class="filter-gold" />
        </a>
      </c-nav-item>
      <c-nav-item class="d-block d-sm-none">
        <a cNavLink routerLink="/contracts" cTooltip="My Contracts" [cTooltipVisible]="showContracts"
          cTooltipTrigger="hover" routerLinkActive="active">
          <img src="assets/svg/contract-{{currentMode}}.svg" height="24px" width="24px" />
        </a>
      </c-nav-item>
    </c-header-nav>
    }
    @if(userService.loggedIn){
    <c-header-nav class="d-none d-md-flex ms-auto ">
      <li class="nav-item position-relative">
        <button class="btn btn-ghost position-relative p-2" (click)="toggleNotificationDropdown()">
          <svg cIcon class="m-0" name="cilBell" size="lg"></svg>
          @if(notificationService.unreadCount > 0){
          <c-badge class="position-absolute top-0 start-100 translate-middle" shape="rounded-pill"
            color="danger">{{notificationService.unreadCount > 99 ? '99+' : notificationService.unreadCount}}</c-badge>
          }
        </button>
        
        @if(showNotificationDropdown){
        <div class="notification-dropdown-menu position-absolute end-0 top-100 mt-2 shadow" 
             [class.show]="showNotificationDropdown"
             (click)="$event.stopPropagation()">
          <ng-container *ngTemplateOutlet="notificationPanel" />
        </div>
        }
      </li>
    </c-header-nav>
    }@else{
    <c-header-nav class="d-none d-md-flex ms-auto ">
    </c-header-nav>
    }

    <c-header-nav class="ms-auto ms-md-0">
      <div class="nav-item py-1">
        <div class="vr h-100 mx-1 text-body text-opacity-75"></div>
      </div>
      <ng-container class="d-none d-sm-flex" *ngTemplateOutlet="themeDropdown" />
      <ng-container *ngTemplateOutlet="languageDropdown" />
      <div class="nav-item py-1">
        <div class="vr h-100 mx-1 text-body text-opacity-75"></div>
      </div>
    </c-header-nav>

    <c-header-nav class="mx-0">
      <ng-container *ngTemplateOutlet="userDropdown" />
    </c-header-nav>

  </c-container>
  <c-container [fluid]="true" class="px-4">
    <c-breadcrumb-router />
    <div>{{userService.userProfile.nameFirst}}</div>
  </c-container>
</ng-container>
<!--</c-header>-->

<ng-template #userDropdown>
  <c-dropdown [popperOptions]="{ placement: 'bottom-start' }" variant="nav-item" *transloco="let t; read 'layout'">

    <button [caret]="false" cDropdownToggle class="py-0 pe-0">
      @if(userService.userProfile.userID > ""){
      <c-avatar shape="rounded-1" [size]="'md'" src="{{userService.getImageURL()}}" status="success"
        textColor="primary" />
      }@else {
      <c-avatar shape="rounded-1" [size]="'md'" src="./assets/images/avatars/login-icon.jpg" status="success"
        textColor="primary" />
      }
    </button>
    @if(userService.userProfile.userID > ""){
    <ul cDropdownMenu class="pt-0 w-auto">
      <li>
        <h6 cDropdownHeader class="bg-body-secondary text-body-secondary fw-semibold py-2 rounded-top">
          {{ t('Account')}} <span class="float-end">BID: {{userService.business.businessID}}</span>
        </h6>
      </li>
      <li>
        <a cDropdownItem (click)="openNotificationDropdown($event)">
          <svg cIcon class="me-2" name="cilBell"></svg>
          {{ t('Updates')}}
          @if(notificationService.unreadCount > 0){
          <c-badge class="ms-2 float-end" color="info">{{notificationService.unreadCount}}</c-badge>
          }
        </a>
        <a cDropdownItem routerLink="/notifications">
          <svg cIcon class="me-2" name="cilHistory"></svg>
          {{ t('Notification History')}}
        </a>
      </li>
      <li>
        <a cDropdownItem routerLink="/posts">
          <!-- <svg cIcon class="me-2" name="cilEnvelopeOpen"></svg> -->
          <img src="assets/svg/posts-{{currentMode}}.svg" height="24px" width="24px" class="filter-gold" />
          {{ t('Posts')}}
          @if(orderService.numPosts > 0){
          <c-badge class="ms-2 float-end" color="success">
            {{orderService.numPosts}}
          </c-badge>
          }
        </a>
      </li>
      <li>
        <a cDropdownItem routerLink="/contracts">
          <svg cIcon class="me-2" name="cilCreditCard"></svg>
          {{ t('To Pay')}}
          @if(contractsService.allContracts.pending.length > 0){
          <c-badge class="ms-2 float-end" color="secondary">
            {{contractsService.tallyOfContracts['numToFund']}}
          </c-badge>
          }
        </a>
      </li>
      <li>
        <h6 cDropdownHeader class="bg-body-secondary text-body-secondary fw-semibold py-2">
          {{ t('Settings')}}
        </h6>
      </li>
      <li></li>
      <li>
        <a cDropdownItem routerLink="/profile">
          <svg cIcon class="me-2" name="cilUser"></svg>
          {{ t('Profile')}}
        </a>
      </li>
      <!-- <li>
        <a cDropdownItem routerLink="">
          <svg cIcon class="me-2" name="cilSettings"></svg>
          {{ t('Settings') }}
        </a>
      </li> -->
      <li>
        <hr cDropdownDivider />
      </li>
      <li>
        <a cDropdownItem routerLink="/logout">
          <svg cIcon class="me-2" name="cilAccountLogout"></svg>
          {{ t('Logout') }}
        </a>
      </li>
    </ul>
    } @else {
    <ul cDropdownMenu class="pt-0 w-auto">
      <li>
        <a cDropdownItem routerLink="/login">
          <svg cIcon class="me-2" name="cilAccountLogout"></svg>
          {{ t('Login') }}
        </a>
      </li>
    </ul>
    }
  </c-dropdown>
</ng-template>

<ng-template #themeDropdown>
  <c-dropdown alignment="end" variant="nav-item" *transloco="let t; read 'layout'">
    <button [caret]="false" cDropdownToggle>
      <svg cIcon [name]="icons()" size="lg"></svg>
    </button>
    <div cDropdownMenu>
      @for (mode of colorModes; track mode.name) {
      <button (click)="colorMode.set(mode.name)" [active]="colorMode()===mode.name" [routerLink]="[]" cDropdownItem
        class="d-flex align-items-center">
        <svg cIcon class="me-2" [name]="mode.icon" size="lg"></svg>
        {{ mode.text }}
      </button>
      }
    </div>
  </c-dropdown>
</ng-template>

<ng-template #languageDropdown>
  <c-dropdown alignment="end" variant="nav-item" *transloco="let t; read 'layout'">
    <button [caret]="false" cDropdownToggle>
      {{ language }}
    </button>
    <div cDropdownMenu>
      @for (dialect of languages; track dialect.name) {
      <button (click)="languageSet(dialect)" [active]="language===dialect.name" [routerLink]="[]" cDropdownItem
        class="d-flex align-items-center">
        {{ dialect.text }}
      </button>
      }
    </div>
  </c-dropdown>
</ng-template>

<ng-template #notificationPanel>
  <div class="notification-panel" *transloco="let t">
    <!-- Header -->
    <div class="notification-panel-header d-flex justify-content-between align-items-center p-3 border-bottom">
      <h6 class="mb-0">
        {{ t('Notifications') }}
        @if(notificationService.unreadCount > 0){
        <c-badge color="danger" shape="rounded-pill" class="ms-2">{{notificationService.unreadCount}}</c-badge>
        }
      </h6>
      <div class="d-flex gap-2">
        @if(notificationService.unreadCount > 0){
        <button class="btn btn-sm btn-link text-decoration-none" (click)="markAllAsRead()">
          {{ t('Mark all read') }}
        </button>
        }
        <button class="btn btn-sm btn-link text-decoration-none" (click)="toggleFilter()">
          <svg cIcon name="cilFilter" size="sm"></svg>
        </button>
      </div>
    </div>

    <!-- Filter (shown when toggled) -->
    @if(showFilter){
    <div class="notification-filter p-2 border-bottom">
      <select class="form-select form-select-sm" [(ngModel)]="notificationFilter" (change)="applyFilter()">
        <option value="all">{{ t('All notifications') }}</option>
        <option value="unread">{{ t('Unread only') }}</option>
        <option value="trade">{{ t('Trade alerts') }}</option>
        <option value="payment">{{ t('Payment updates') }}</option>
        <option value="system">{{ t('System messages') }}</option>
      </select>
    </div>
    }

    <!-- Notification List -->
    <div class="notification-list">
      @if(getFilteredNotifications().length === 0){
      <div class="text-center py-4 text-muted">
        <svg cIcon name="cilBellExclamation" size="xl" class="mb-2"></svg>
        <p class="mb-0">{{ t('No notifications') }}</p>
      </div>
      }

      @for(notification of getFilteredNotifications(); track notification.key; let i = $index){
        @if(i < maxNotificationsShown){
        <div class="notification-item d-flex p-3 border-bottom" 
             [class.unread]="!notification.isRead"
             [class.clickable]="notification.callToActionLink"
             (mouseenter)="hoveredNotification = notification.key || null"
             (mouseleave)="hoveredNotification = null"
             (click)="notification.callToActionLink ? navigateToCallToAction(notification.callToActionLink) : null">
          
          <!-- Notification Icon/Badge -->
          <div class="notification-icon me-3">
            <c-badge [color]="setColor(notification.msgType)" class="p-2">
              @switch(notification.msgType){
                @case('payment'){<svg cIcon name="cilDollar" size="sm"></svg>}
                @case('trade'){<svg cIcon name="cilCart" size="sm"></svg>}
                @case('urgent'){<svg cIcon name="cilWarning" size="sm"></svg>}
                @default{<svg cIcon name="cilBell" size="sm"></svg>}
              }
            </c-badge>
          </div>

          <!-- Notification Content -->
          <div class="notification-content flex-grow-1">
            <div class="notification-message">
              {{ notification.message }}
            </div>
            <div class="notification-time text-muted small">
              {{ notification.duration }} ago
            </div>
          </div>

          <!-- Actions -->
          <div class="notification-actions ms-2" [class.visible]="hoveredNotification === notification.key">
            @if(!notification.isRead){
            <button class="btn btn-sm btn-ghost p-1" 
                    (click)="markNotificationAsRead(notification.key)"
                    cTooltip="Mark as read">
              <svg cIcon name="cilCheckCircle" size="sm"></svg>
            </button>
            }
            <button class="btn btn-sm btn-ghost p-1" 
                    (click)="deleteNotification(notification.key)"
                    cTooltip="Delete">
              <svg cIcon name="cilTrash" size="sm"></svg>
            </button>
          </div>
        </div>
        }
      }
    </div>

    <!-- Footer -->
    <div class="notification-panel-footer p-3 border-top">
      <div class="d-flex justify-content-between">
        <a routerLink="/notifications" class="text-decoration-none" (click)="hideUpdates()">
          {{ t('View all notifications') }}
        </a>
        @if(getFilteredNotifications().length > 0){
        <button class="btn btn-sm btn-link text-danger text-decoration-none" (click)="clearAllNotifications()">
          {{ t('Clear all') }}
        </button>
        }
      </div>
    </div>
  </div>
</ng-template>